import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiError } from "@/lib/api";
import { Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { BellRinging, PencilSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export function DispatchChecksPanel() {
  const qc = useQueryClient();
  const { data: rows = [] } = useQuery({ queryKey: ["dispatch-checks"], queryFn: async () => (await api.get("/dispatch-checks")).data, refetchInterval: 30000 });
  const { data: q } = useQuery({ queryKey: ["dispatch-check-qs"], queryFn: async () => (await api.get("/dispatch-checks/questions")).data });
  const [edit, setEdit] = useState(null);
  useEffect(() => { if (q && edit === null) setEdit(false); }, [q, edit]);
  const save = async () => {
    try { await api.put("/dispatch-checks/questions", { questions: edit.split("\n") }); toast.success("Questions saved"); setEdit(false); qc.invalidateQueries({ queryKey: ["dispatch-check-qs"] }); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const nos = rows.filter((r) => !r.all_yes).length;
  return (
    <Panel className="p-5 mb-5" data-testid="dispatch-checks-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <p className="font-heading font-bold text-slate-900 flex items-center gap-2"><BellRinging size={18} className="text-red-500" />Dispatcher 30-min checks · today</p>
        <div className="flex items-center gap-3 text-xs"><span className="text-slate-500">{rows.length} answered · <b className="text-red-500">{nos} with a No</b></span>
          <button onClick={() => setEdit(typeof edit === "string" ? false : (q?.questions || []).join("\n"))} className="inline-flex items-center gap-1 font-semibold text-blue-600" data-testid="dc-edit-questions"><PencilSimple size={13} />Edit questions</button></div>
      </div>
      {typeof edit === "string" && <div className="mb-4 space-y-2"><Textarea rows={6} value={edit} onChange={(e) => setEdit(e.target.value)} data-testid="dc-questions-input" /><p className="text-[11px] text-slate-400">One question per line.</p><Button onClick={save} className="h-8 bg-slate-900 text-white text-xs" data-testid="dc-questions-save">Save questions</Button></div>}
      {!rows.length ? <p className="text-sm text-slate-400">No checks answered yet today.</p> : (
        <div className="max-h-72 overflow-y-auto divide-y divide-slate-100">{rows.map((r) => (
          <div key={r.id} className="py-2.5 flex gap-3 text-sm" data-testid={`dc-row-${r.id}`}>
            <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${r.all_yes ? "bg-emerald-500" : "bg-red-500"}`} />
            <div className="flex-1 min-w-0"><p className="text-slate-900"><b>{r.user_name}</b> · {r.all_yes ? "All yes" : `${r.answers.filter((a) => !a.yes).length} No`}</p>
              {r.answers.filter((a) => !a.yes).map((a) => <p key={a.question} className="text-xs text-red-600">✗ {a.question} — {a.reason}</p>)}</div>
            <span className="text-[11px] text-slate-400">{new Date(r.at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</span>
          </div>))}</div>
      )}
    </Panel>
  );
}
